import { SpeakerItem } from "./SpeakerEditor";
import { AppUnderlinedTitle } from "../../../../../../shared/components/AppUnderlinedTitle";
import { useSpeakerEditor } from "../../../../hooks/use-speaker-editor";
import { useAppSelector } from "../../../../../../services/redux/hooks/use-selector";
import {
  selectRecognizeMetaObject,
  selectTranscriptionInfo,
  selectUniqueSpeakers,
} from "../../../../redux/selectors";
import styles from "./styles.module.css";
import { ArrowIcon } from "../../../../../../shared/icons/ArrowIcon";
import { AppIconButton } from "../../../../../../shared/components/AppIconButton";
import { useEffect, useState } from "react";
import classNames from "classnames";
import { TranscriptInfoBlock } from "../TranscriptEditor/TranscriptInfoBlock";
import { TMeetingInfo } from "../../../../../../services/api/instances/meetingsApi/types";
import { useStorageSelectors } from "../../../../../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { useTranslation } from "react-i18next";
import { AddButton } from "../../../../../../common/Components/Buttons/AddButton";

export const SpeakerEditor = () => {
  const {
    handleSpeakerActions,
    handleAddNewSpeaker,
    handleDeleteSpeaker,
    handleChangeTranscriptionInfo,
  } = useSpeakerEditor();
  const uniqSpeakers = useAppSelector(selectUniqueSpeakers);
  const info = useAppSelector(selectTranscriptionInfo);
  const { selectedId } = useStorageSelectors("meetings");
  const recognizeMeta = useAppSelector((state) =>
    selectRecognizeMetaObject(state, selectedId as string)
  );
  const [isOpenBlock, setIsOpenBlock] = useState<boolean>(false);
  const { t } = useTranslation();

  return (
    <div className={styles["speakers-container"]}>
      <AppUnderlinedTitle
        leftContent={t("meetings.common_info")}
        className={styles["speakers-block-header"]}
      >
        <div>
          <AddButton
            text={t("meetings.add_speaker")}
            typeBtn={"text_btn"}
            onClick={() => {
              setIsOpenBlock(true);
              handleAddNewSpeaker();
            }}
          />
          <AppIconButton
            onClick={() => setIsOpenBlock(!isOpenBlock)}
            className={classNames(!isOpenBlock && styles["btn-rotate"])}
          >
            <ArrowIcon />
          </AppIconButton>
        </div>
      </AppUnderlinedTitle>
      <div
        className={classNames(
          styles["item-container"],
          !isOpenBlock && styles["item-container-close"]
        )}
      >
        <TranscriptInfoBlock
          info={info as TMeetingInfo}
          handleChangeInfo={handleChangeTranscriptionInfo}
          isDisabled={recognizeMeta?.is_recognize}
        />
        {uniqSpeakers?.map((speaker, index) => (
          <SpeakerItem
            key={`${speaker.speaker_group_key}-${index}`}
            speaker={speaker}
            serialNumber={index + 1}
            handleSpeakerDelete={handleDeleteSpeaker}
            handleSpeakerActions={handleSpeakerActions}
          />
        ))}
      </div>
    </div>
  );
};
